import {
  getLeoUuid,
  LeoUUID,
  getObject,
  getBoolean,
} from "@surya-digital/leo-ts-types";
import { SurveyLanguageCode, SurveyLanguageCodeDTO } from "./surveyLanguageCode";

export interface SurveyLanguageDTO {
  languageId: string;
  languageCode: SurveyLanguageCodeDTO;
  isRTL: boolean;
}

export class SurveyLanguage {
  readonly isSurveyLanguageSurveyLanguage: boolean = true;

  readonly languageId: LeoUUID;
  readonly languageCode: SurveyLanguageCode;
  readonly isRTL: boolean;


  constructor(
  languageId: LeoUUID, 
  languageCode: SurveyLanguageCode, 
  isRTL: boolean
  ) {
    this.languageId = languageId;
    this.languageCode = languageCode;
    this.isRTL = isRTL;
  }

  static fromDTO(dto: SurveyLanguageDTO): SurveyLanguage {
    const languageId = getLeoUuid(dto, "languageId", InvalidSurveyLanguageLanguageIdError);
    const languageCode = SurveyLanguageCode.fromDTO(getObject(dto, "languageCode", InvalidSurveyLanguageLanguageCodeError));
    const isRTL = getBoolean(dto, "isRTL", InvalidSurveyLanguageIsRtlError);
    return new SurveyLanguage(
      languageId,
      languageCode,
      isRTL
    );
  }

  toDTO(): SurveyLanguageDTO {
    const dto: SurveyLanguageDTO = {
        languageId: this.languageId.toDTO(),
        languageCode: this.languageCode.toDTO(),
        isRTL: this.isRTL
    };
    return dto;
  }
  }

SurveyLanguage.prototype.toString = function toString(): string {
  return `SurveyLanguage(languageId='${this.languageId}',languageCode='${this.languageCode}',isRTL='${this.isRTL}')`;
};

export class InvalidSurveyLanguageError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyLanguageError";
  }
}
export class InvalidSurveyLanguageLanguageIdError extends InvalidSurveyLanguageError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyLanguageLanguageIdError";
  }
}

export class InvalidSurveyLanguageLanguageCodeError extends InvalidSurveyLanguageError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyLanguageLanguageCodeError";
  }
}

export class InvalidSurveyLanguageIsRtlError extends InvalidSurveyLanguageError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyLanguageIsRtlError";
  }
}
